import { useEffect, useRef } from "react";

/**
 * Adds .is-visible to the element when it enters the viewport.
 * Pair with `.scroll-reveal` or `.kinetic` CSS classes.
 */
export default function useScrollReveal(threshold = 0.18, once = true) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          if (once) obs.unobserve(e.target);
        } else if (!once) {
          e.target.classList.remove("is-visible");
        }
      });
    }, { threshold });
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold, once]);
  return ref;
}
